/**
 * Styles de positionnement pour le widget Ringado
 * Positionnement amélioré pour un meilleur design
 */
export const POSITIONING_STYLES = `
  /* Widget container */
  .ringado-widget {
    position: fixed;
    z-index: 1000000;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Position du widget */
  .ringado-widget.bottom-right {
    bottom: 24px;
    right: 24px;
  }

  .ringado-widget.bottom-left {
    bottom: 24px;
    left: 24px;
  }

  .ringado-widget.top-right {
    top: 24px;
    right: 24px;
  }

  .ringado-widget.top-left {
    top: 24px;
    left: 24px;
  }

  /* Responsive positioning for mobile */
  @media (max-width: 480px) {
    .ringado-widget.bottom-right {
      bottom: 16px;
      right: 16px;
    }

    .ringado-widget.bottom-left {
      bottom: 16px;
      left: 16px;
    }

    .ringado-widget.top-right {
      top: 16px;
      right: 16px;
    }

    .ringado-widget.top-left {
      top: 16px;
      left: 16px;
    }
  }
`;
